// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/round-chevron_left-24px.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/img/round-chevron_right-24px.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
DRAWER
*/

/* Common Drawer Settings */
#NavDrawer {
  display: block !important;
  background-color: #fff !important;
  flex: none !important;
  padding: 0 !important;
  overflow: hidden !important;
  opacity: 0 !important;
  visibility: hidden !important;
}
#NavDrawer.drawerStart,
#NavDrawer.drawerMainMenu,
#NavDrawer.drawerAllAppsMenu,
#NavDrawer.drawerCollapsed {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04) !important;
  opacity: 1 !important;
  visibility: visible !important;
  z-index: 100;
}
/* Drawer expanded */
.drawerStart,
.drawerAllAppsMenu,
.drawerMainMenu {
  min-width: 350px !important;
  max-width: 350px !important;
  width: 350px !important;
}

.ant-menu-horizontal {
  border-bottom: none;
}

main.ant-layout-content {
  /* width: calc(100vw - 350px) !important; */
}

@media only screen and (max-width: 900px) {
  #NavDrawer .mainMenuItem {
    display: none !important;
  }

  #NavDrawer .menu-scroll ul.mainMenu--mobile {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  #NavDrawer .menu-scroll ul.mainMenu--mobile .ant-menu-item {
    margin: 0 !important;
  }
  #NavDrawer .menu-scroll ul.mainMenu--mobile .navigation-icon {
    display: flex !important;
    justify-content: space-between;
  }

  #NavDrawer .menu-scroll ul.mainMenu--mobile .close-icon {
    position: fixed;
    right: 26px;
    top: 26px;
  }

  #NavDrawer .menu-scroll ul.mainMenu--mobile .menu-notification {
    position: fixed;
    right: 65px;
    top: 14px;
    border: none !important;
  }

  #NavDrawer .mainMenu--mobile .mainMenuItem {
    display: block !important;
    line-height: inherit !important;
    border: 1px solid #F8F8F8 !important;
  }

  .mainMenuItem:nth-child(n + 5) {
    display: block !important;
  }

  #NavDrawer .menu-notification {
    display: block !important;
  }

  .app-drawer-header--hidden {
    display: none !important;
  }

  #NavDrawer .menu-scroll {
    justify-content: space-between;
  }

  #NavDrawer .menu-scroll {
    justify-content: space-between;
  }

  .ant-menu-overflowed-submenu {
    display: none !important;
  }

  /* #drawer_container {
    display: none !important;
  } */

  .menuitem-overflowed {
    display: block !important;
    border-bottom: 1px solid #F8F8F8 !important; 
  }

  #NavDrawer .mainMenu--mobile .ant-menu-item {
    width: inherit !important;
  }

  #NavDrawer .mainMenu--mobile .ant-menu-item a.icon {
    justify-self: flex-start !important;
    width: 100%;
  }

  .menuMobile--avatar {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
  }

  #NavDrawer .mainMenu--mobile .menuMobile--avatar .user-name {
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
  }

  #NavDrawer .mainMenu--mobile .menuMobile--avatar .avatar-menu--icon {
    display: none;
  }

  #NavDrawer .mainMenu--mobile .availabilityText {
    display: block !important;
  }

  #NavDrawer .mainMenu--mobile .availabilityIcon {
    padding: 10px;
  }

  #NavDrawer .mainMenu--mobile .availabilityBtn--mobile {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 100% !important;
    width: 100%;
    padding: 0 30px 0 10px;
    justify-content: space-between;
  }

  #NavDrawer .mainMenu--mobile .availabilityBtn--mobile .warning-text {
    padding-left: 20px;
  } 

  #NavDrawer .mainMenu--mobile .availabilityBtn--mobile .availabilityContent--mobile {
    display: flex;
  }

  #NavDrawer .mainMenu--mobile .ant-menu-item-selected span {
    background-color: transparent !important;
  }

  #NavDrawer .mainMenu--mobile .ant-menu-item.ant-menu-item-disabled .menuMobile--arrowRight {
    display: none;
  }

  #NavDrawer .mainMenu--mobile .ant-menu-item.ant-menu-item-disabled .lock-icon {
    padding-right: 6px;
    padding-left: 0;
  }
}

.mainMenu--mobile {
  width: 100vw;
  height: 100vh;
  z-index: 20;
  flex-direction: column !important;
  align-items: flex-start !important;
  margin-top: 100px !important;
}

.mainMenu--mobile--visible {
  display: block;
}

.mainMenu--mobile--hidden {
  display: none;
}

.nav-right--mobile {
  display: flex;
  margin-left: 0 !important;
  position: fixed;
  right: 20px;
  top: -2px;
}

.availabilityBtn--mobile {
  position: fixed !important;
  top: 40px;
}

.mainMenu--visible {
  display: block;
}

.mainMenu--hidden {
  display: none;
}

.mobileMenu--close {
  position: fixed;
  right: 20px;
  top: 20px;
}

@media only screen and (max-width: 1400px) {
  .drawerStart,
  .drawerAllAppsMenu,
  .drawerMainMenu {
    min-width: 260px !important;
    max-width: 260px !important;
    width: 260px !important;
  }
}

/* Drawer collapsed */
.drawerCollapsed {
  min-width: 68px !important;
  max-width: 68px !important;
  width: 68px !important;
}

.expires-warning {
  text-align: left;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #ff784e;
}

.expires-warning-update {
  text-decoration: underline;
}

.open-to-offer-warning {
  text-align: left;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0;
  color: #888888;
  opacity: 1;
}
/* Common vertical alignment
(stretching navDrawer vertically) */
.ant-layout-sider-children {
  display: grid !important;
  width: 100% !important;
}
.is-not-mobile .ant-layout-sider-children {
  height: 90% !important;
  position: fixed;
  width: 350px !important;
}

@media only screen and (max-width: 1400px) {
  .is-not-mobile .ant-layout-sider-children {
    width: 260px !important;
  }
}

.drawerCollapsed.is-not-mobile .ant-layout-sider-children {
  width: 68px !important;
}

#NavDrawer.drawerAllAppsMenu {
  grid-template-rows: 216px 1fr !important;
}
.drawerAllAppsMenu .emptyField {
  height: 0;
}
.emptyField {
  height: 148px;
}
/*
LOGO BLOCK
*/
/* Common Logo box settings */
#NavDrawer .logo {
  /*  background: rgba(255, 255, 100, 1) !important; */
  position: relative !important;
  overflow: hidden !important;
  height: 124px !important;
}
/* Logo box expanded */
.drawerStart .logo,
.drawerMainMenu .logo,
.drawerAllAppsMenu .logo {
  margin: 40px 24px 52px 24px;
  width: 272px !important;
}

/* Logo box collapsed */
.drawerCollapsed .logo {
  margin: 40px 18px 52px 18px !important;
  width: 32px !important;
}

/* Logo sign */
.logo img {
  width: 32px !important;
  height: 32px !important;
}

/*
Turing title
*/
/* Common Turing title styles */
.logo h1 {
  color: #444444;
  font-weight: 700;
  font-size: 20px !important;
  padding: 0 !important;
  line-height: 1rem !important;
  margin: 40px 0 10px 0 !important;
}

/* Visible App Title Style */
.logo h2 {
  color: #42a5f5;
  font-size: 20px !important;
  padding: 0 !important;
  line-height: 1rem !important;
  white-space: nowrap;
  font-weight: lighter;
}

/* Color of All Apps title */
.drawerAllAppsMenu .logo h2 {
  color: #888888;
}

/* Visible Turing title (expanded nav Drawer) */
.drawerMainMenu .logo h1,
.drawerMainMenu .logo h2,
.drawerAllAppsMenu .logo h1,
.drawerAllAppsMenu .logo h2 {
  opacity: 1 !important;
  visibility: visible !important;
}

/* Hidden Turing title and App title (collapsed nav Drawer) */
.drawerCollapsed .logo h1,
.drawerCollapsed .logo h2 {
  opacity: 0 !important;
  visibility: visible !important;
}

/*
MENU STYLING
Main Menu styles dependence
from state of NavDrawer
*/

/* Common menu settings */
#NavDrawer .mainMenu {
  text-align: left !important;
}
#NavDrawer {
  /* height:100vh !important; */
}
/* Expanded menu settings */
.drawerStart .mainMenu,
.drawerMainMenu .mainMenu,
.drawerAllAppsMenu .mainMenu {
  width: 350px !important;
  /* margin: 0 0 20px 0 !important; */
}

.drawerMainMenu .mainMenu {
  width: 100vw !important;
}

/* Visible states of menu settings */
.drawerCollapsed .mainMenu,
.drawerStart .mainMenu,
.drawerMainMenu .mainMenu {
  padding: 0 0 0 8px !important;
  /* height: 100%; */
  /* max-height:100%;
  height: calc(100vh - 216px - 48px - 100px) !important; */
  /*  overflow: auto !important; */
  display: flex;
  flex-direction: row;
  opacity: 1 !important;
  visibility: visible !important;
  align-items: center;
}

/* Collapsed menu settings */
.drawerCollapsed .mainMenu {
  width: 68px !important;
  margin: 0 !important;
  padding: 0 0 0 10px !important;
}
/* Hidden states of menu settings */
.drawerAllAppsMenu .mainMenu {
  margin: 0 8px !important;
  padding: 0 !important;
  max-height: 0 !important;
  overflow: hidden !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.ant-dropdown-menu {
  width: 140px;
  text-align: right;
  left: calc(84%) !important;
}

.ant-dropdown-menu-item:hover {
  background: rgba(46, 110, 223, 0.08);
  color: #2e6edf !important;
}

.ant-dropdown-menu-item.btn-link-font:hover {
  background: rgba(46, 110, 223, 0.08);
  color: #2e6edf;
}

/*
Menu items common settings
*/
#NavDrawer .allApps-menu .ant-menu-item,
#NavDrawer .mainMenu .ant-menu-item,
#NavDrawer .ant-menu-submenu-title {
  margin: 2px 4px !important;
}
#NavDrawer .ant-menu-submenu-title {
  height: 48px !important;
}
#NavDrawer .container {
  height: 48px !important;
}
#NavDrawer .ant-menu-submenu-active,
#NavDrawer .material-icons,
#NavDrawer .ant-menu-item a.icon,
#NavDrawer .icon {
  margin: 0px;
  padding: 0px;
  justify-self: center;
  /*background-color: white; Look really bad */
}
#NavDrawer .text,
#NavDrawer .label {
  align-self: center;
  padding-top: 2px;
}

/*
MENU ITEMS
*/

#NavDrawer .ant-menu-submenu-title {
  padding: 0 !important;
  margin: 0 !important;
}

.mainMenu .ant-menu-submenu,
.mainMenu .ant-menu-submenu-title {
  margin: 0 !important;
  padding: 0 !important;
  height: auto !important;
  width: 10% !important;
}
/* Menu items common styles */
.mainMenu .ant-menu-item,
.mainMenu .ant-menu-submenu-title .container,
.mainMenu .ant-menu-sub .ant-menu-item,
.allApps-menu .ant-menu-item {
  font-size: 16px !important;
  height: 48px !important;
  color: #444444 !important;
  line-height: 0 !important;
  width: 10% !important;
}
.mainMenu .ant-menu-item-selected,
.mainMenu .ant-menu-submenu-title {
  border-radius: 2rem !important; /* Keep the round border, it looks better */
}
/* clean old style */
.ant-menu-inline .ant-menu-item,
.ant-menu-inline-collapsed .ant-menu-item {
  padding: 0 !important;
}

/* Collapsed submenu */

.mainMenu .ant-menu-submenu {
  margin: 0px !important;
  padding: 0px !important;
  background: rgba(255, 255, 255, 0) !important;
  height: auto !important;
}
.mainMenu .ant-menu-sub {
  margin: 0px !important;
  padding: 5px 14px !important;
  background: rgba(255, 255, 255, 0) !important;
  max-height: auto !important;
}
/* SubMenu items */
.drawerAllAppsMenu .ant-menu-sub .ant-menu-item,
.drawerStart .ant-menu-sub .ant-menu-item,
.drawerMainMenu .ant-menu-sub .ant-menu-item {
  margin: 2px 0 !important;
  padding: 0 !important;
}
/* Removing default shadow in expanding menu */
.ant-menu-inline {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) inset !important;
}

/*
Menu titles and labels
*/

/* Icons */
.ant-menu-item .material-icons-round,
.ant-menu-sub .ant-menu-item i.anticon,
.ant-menu-submenu-title .material-icons-round {
  font-size: 24px;
  color: #444444;
}

/* Selected MENU styles item */
.ant-menu-item-selected {
  font-weight: 500;
}
.ant-menu-item-selected .material-icons,
.ant-menu-item-selected span,
.ant-menu-item-selected i {
  color: #1890ff;
  border-bottom-color: none !important;
  background-color: #2e6edf14;
}

/* Submenu arrows styles*/
.ant-menu-submenu .ant-menu-submenu-arrow {
  top: 50% !important;
  right: 16px !important;
  color: #444444 !important;
}

/* Selected SUBMENU item*/
.ant-menu-sub .ant-menu-item {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
  margin-right: 16px !important;
  padding-left: 16px !important;
  padding-top: 3px;
  padding-bottom: 3px;
  border-radius: 2rem; /* Look better */
  font-size: 16px;
  color: #666666;
}

/*
Submenu popups
*/

/* Popups windows inside paddings */
.ant-menu-submenu-popup .ant-menu-sub {
  padding: 1rem 0.5rem !important;
}

.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item {
  margin: 0 auto !important;
}
/* popup menus */
.ant-menu-submenu-popup .ant-menu-sub,
.ant-menu-submenu-popup .ant-menu-item,
.ant-menu-submenu-popup .ant-menu-item span {
  width: auto !important;
}
.ant-menu-submenu-popup {
  left: 75px !important;
  width: auto !important;
}
.ant-menu-submenu-popup .ant-menu-item {
  display: grid !important;
  margin: 0 12px !important;
  border-radius: 0 !important;
}

/* Menu items hover effects */
.ant-menu-item-selected.bgc-turing-ly-dashboard .text,
.ant-menu-item-selected.bgc-turing-ly-dashboard:hover .text,
.ant-menu-item-selected.bgc-turing-ly-dashboard .text:hover {
  color: rgba(236, 64, 122, 1) !important;
}
.ant-menu-root
  .ant-menu-submenu-active:not(.ant-menu-item-selected)
  .ant-menu-submenu-title,
.ant-menu-root .ant-menu-item-active:not(.ant-menu-item-selected),
.ant-menu-root
  .ant-menu-item.ant-menu-item-active:not(.ant-menu-item-selected) {
  background-color: #2e6edf14;
  color: #2e76d4;
  border-radius: 0.6rem !important;
}

/*
Log Out
*/
/* Log Out on expanded Drawer */
.LogOut {
  width: 100%;
  /* height: 80px;
  max-height: 80px; */
  overflow: hidden;
  /* padding: 24px 20px; */
  /* position: fixed;
  bottom: 68px; */
  background-color: #fff;
  /* box-shadow: 0px -10px 10px -10px rgba(0,0,0,0.1); */
  /* z-index: 100; */
  cursor: pointer;
}
/* Log Out on collapsed Drawer */
.drawerCollapsed .LogOut {
  width: 68px;
  padding: 24px 16px;
  text-align: center;
  overflow: hidden;
}
/* Visible user name on expanded Drawer */
.LogOutText {
  margin-left: 16px;
}
/* Inisible user name on expanded Drawer */
.drawerCollapsed span.LogOutText {
  opacity: 0;
  visibility: hidden;
  height: 0;
  width: 0;
  overflow: hidden;
}

/*
Collapsing trigger
*/

/* Common collapsing trigger for all states */
.ant-layout-sider-trigger {
  height: 68px;
  padding-right: 32px;
  border-top: 1px solid #eeeeee;
  text-align: right;
  background-color: #fafafa;
  position: fixed;
  bottom: 0;
  cursor: pointer;
}
/* Collapsing trigger expanded */
.drawerMainMenu .ant-layout-sider-trigger,
.drawerStart .ant-layout-sider-trigger,
.drawerAllAppsMenu .ant-layout-sider-trigger {
  width: 350px !important;
  z-index: 100;
}

@media only screen and (max-width: 1400px) {
  .drawerMainMenu .ant-layout-sider-trigger,
  .drawerStart .ant-layout-sider-trigger,
  .drawerAllAppsMenu .ant-layout-sider-trigger {
    width: 260px !important;
  }
}

/* Collapsing trigger expanded icon */
.ant-layout-sider-trigger i {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 22px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: contain;
  background-position: center center;
  vertical-align: middle;
}
/* Removing default chevron */
.ant-layout-sider-trigger i svg {
  display: none;
}

/* Collapsing trigger collapsed */
.drawerCollapsed .ant-layout-sider-trigger {
  width: 68px !important;
  padding-left: 20px !important;
}

/* Collapsing trigger collapsed icon */
.ant-layout-sider-collapsed .ant-layout-sider-trigger i {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-size: contain;
  background-position: center center;
}
/* Hiding icons in popups and tooltips */
.ant-menu-submenu-popup .material-icons,
.ant-tooltip-inner .material-icons {
  display: none;
}
/* Tooltips styles */
.ant-tooltip-inner .label {
  padding: 2px 2px 0 2px;
  display: none;
}

#NavDrawer .ant-menu.ant-menu-dark .ant-menu-item-selected,
#NavDrawer .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background-color: rgba(66, 165, 245, 0.08);
}

#NavDrawer .ant-menu-inline .ant-menu-selected::after,
#NavDrawer .ant-menu-inline .ant-menu-item-selected::after {
  opacity: 0;
}

/* Mobile screen Menu button */

#mob-menu-btn {
  display: none;
  position: fixed;
  top: 20px;
  right: 23px;
  z-index: 999;
  padding: 5px 10px 5px 10px;
  width: auto;
  height: auto;
  cursor: pointer;
  /* background-color: #FFF; */
  border-radius: 4px;
  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04) !important; */
}

#mob-menu-btn .bar1,
.bar2,
.bar3 {
  display: block;
  width: 27px;
  height: 2px;
  background-color: #212121;
  margin: 6px 0;
  transition: 0.4s;
}

#NavDrawer.is-mobile + #mob-menu-btn .bar1 {
  -webkit-transform: rotate(-45deg) translate(-7px, 4px);
  transform: rotate(-45deg) translate(-7px, 4px);
}

#NavDrawer.is-mobile + #mob-menu-btn .bar2 {
  opacity: 0;
}

#NavDrawer.is-mobile + #mob-menu-btn .bar3 {
  -webkit-transform: rotate(45deg) translate(-6px, -6px);
  transform: rotate(45deg) translate(-6px, -6px);
}

@media (min-width: 350px) and (max-width: 900px) {
  #NavDrawer {
    position: fixed;
    top: 0;
    z-index: 998 !important;
    width: 70% !important;
    min-width: 70% !important;
    -webkit-transition: all 0.25s !important;
    transition: all 0.25s !important;
  }

  .mobileHeader {
    display: flex;
    justify-content: center;
    background-color: white !important;
    z-index: 3;
  }

  .mobileHeader.mobileVisible {
    display: flex;
    justify-content: space-between !important;
  }

  .mobileHeader .logoHolder {
    display: flex;
    gap: 5px;
    padding: 20px;
  }

  .mobile-header-notification {
    font-size: 26px;
    line-height: 26px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 16px;
    flex: 1;
  }

  .mobile-header-notification > svg {
    font-size: 26px;
  }

  .mobile-header-text {
    height: 70px;
    padding: 20px;
  }

  .titleBlock {
    padding-top: 2rem;
    padding-left: 0 !important;
  }

  .ant-layout-header h1 {
    font-size: 20px !important;
    margin-left: 0 !important;
  }

  .secondaryTitle.ant-layout-header {
    padding-left: 30px !important;
    box-shadow: none !important;
  }

  .mainMenu .ant-menu-item,
  .mainMenu .ant-menu-submenu-title .container,
  .mainMenu .ant-menu-sub .ant-menu-item,
  .allApps-menu .ant-menu-item {
    font-size: 12px !important;
  }

  .mobileMenuRight {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding-right: 20px;
  }

  #NavDrawer.is-mobile {
    left: 0;
    -webkit-transition: all 0.25s !important;
    transition: all 0.25s !important;
  }
  #NavDrawer.is-mobile .logo {
    height: 80px !important;
    margin: 10px 24px;
    display: flex;
    justify-content: space-between;
    width: 60vw !important;
  }
  #NavDrawer.is-mobile .logo .logo-img {
    display: none;
  }
  #NavDrawer.is-mobile .logo h1 {
    margin: 8px 0 15px 0 !important;
  }
  .mainMenuContainer {
    display: block;
    position: absolute;
    top: 89px;
    width: 100%;
  }
  #NavDrawer ul.mainMenu {
    width: 100% !important;
    padding-right: 10px !important;
  }
  #NavDrawer .ant-layout-sider-trigger {
    display: none;
  }
  #NavDrawer .LogOut {
    bottom: 0;
  }

  #mob-menu-btn {
    display: block !important;
  }

  .ant-layout .titleBlock {
    padding: 1rem 0 0 1rem;
  }
  /* .ant-layout-header h1 {
    margin: 20px 0 0 10px !important;
  } */
  .ant-layout .ant-layout-content {
    width: 100% !important;
    max-width: 100%;
  }

  .ant-table-body {
    overflow-x: auto;
  }
}

.launchScreen .ant-menu-item,
#NavDrawer .ant-menu-item,
#NavDrawer .mainMenu .ant-menu-submenu-title > .container {
  width: auto !important;
  grid-template-columns: none !important;
}

.divider {
  margin: 10px;
  background-color: #eee;
}

#NavDrawer .icon {
  align-items: center;
  justify-content: center;
  /* border-left: 10px solid white;  */
}

.ant-menu-item-active .icon {
  /* border-left: 10px solid #E9E9E9 !important; */
}

.ant-menu-item-selected .icon {
  /* border-left: 10px solid #EEEEEE !important; */
}

@media (min-width: 350px) and (max-width: 900px) {
  #NavDrawer ul.mainMenu {
    width: 100% !important;
    padding-right: 10px !important;
    display: flex;
  }

  #NavDrawer.drawerMainMenu {
    /* opacity: 0 !important;
    visibility: hidden !important; */
    background: transparent !important;
  }

  .close-icon {
    display: block;
    position: fixed;
    right: 20px;
    top: 10px;
  }
}

.close-icon {
  display: none;
}

.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  border-bottom: none !important;
  background: #2e6edf14;
  border-radius: none;
}

#ant-menu-item-selected {
  border-bottom: none !important;
  background: #2e6edf14;
  border-radius: none;
  color:#1890ff !important;
}

#ant-menu-item-selected a{
  color:#1890ff !important;
}

.mainMenu .ant-menu-item-selected,
.mainMenu .ant-menu-submenu-title {
  border-radius: 0.6rem !important;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #eeeeee;
  border-radius: 0 !important;
}

.menu-item-disabled {
  opacity: 0.5;
}

.lock-icon {
  padding-left: 10px;
}

.user-profile {
  cursor: pointer;
}

.title-row {
  width: 100%;
  font: normal normal normal 14px/19px;
  font-weight: 300;
  color: #888888;
}

.challenge-status-icon {
  border-radius: 50px;
  margin-right: 20px !important;
  color: white !important;
  font-weight: 500;
}

.callout-icon {
  background-color: orange !important;
}

.passed-icon {
  background-color: #77bb58 !important;
}

.availabilityIcon {
  opacity: 1;
  fill: #444;
}

.availabilitySection {
  /* margin-top: 20px; */
  /* bottom: 10px; */
  /* position: fixed;
  bottom: 152px; */
  z-index: 100;
  align-self: flex-end;
}

.flex-section {
  display: flex;
  flex: 1;
}

.availabilityBtn {
  /* background-color: #eaeaea !important; */
  display: flex;
  align-items: center;
  border-radius: 50px;
  border: none !important;
  height: 50px !important;
  max-width: 240px !important;
  /* top: -68px; */
  text-align: left;
}

.availabilityBtn.ant-btn {
  padding: 8px 12px;
  /* margin-bottom: -26px; */
}

.nav-right {
  display: flex;
  margin-left: auto;
  margin-right: 20px;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.availabilityText {
  margin: 5px;
}

@media only screen and (max-width: 1100px) {
  .availabilityText {
    display: none !important;
  }

  .user-name {
    display: none;
  }
}

.drawerCollapsed .availabilitySection {
  width: 50px !important;
  min-width: 50px !important;
  overflow: hidden;
}

.drawerCollapsed span.availabilityText {
  opacity: 0;
  display: none;
  height: 0;
  width: 0;
  overflow: hidden;
  margin: 0;
}

/* Side Navigation refactor styling */
#drawer_container {
  position: fixed;
  /* height: 100%; */
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.user-name {
  padding-right: 10px;
}

.menu-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.menu-scroll {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.flex {
  flex: 1 !important;
}

#turing_logo {
  display: block;
}

#title {
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
}

#t_logo {
  display: block;
}

#app-drawer-header svg {
  display: none;
}

#app-drawer-header {
  padding: 0 24px;
  /* padding-top: 25px; */
  /* min-height: 166px; */
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.ant-layout-sider-collapsed #t_logo {
  display: block;
}

.ant-layout-sider-collapsed #turing_logo {
  display: none;
}

.main-menu {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
}

.bottom-menu {
  height: 48px !important;
}

/* #app-drawer{
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
  transition-property: width, visibility;
} */

.ant-layout-sider-collapsed .title-row {
  display: none;
}

.ant-menu-submenu-selected {
  border-bottom-color: none !important;
}

.drawerCollapsed .availabilityBtn {
  border-radius: 50%;
  height: 50px !important;
  width: 50px !important;
  min-width: 50px !important;
  margin-left: 0 !important;
}

.avatar-user {
  margin-left: 12px;
}

.drawerCollapsed .avatar-user {
  display: none;
}

.avatar-container {
  margin-left: 9px;
}

#drawer_spacer {
  width: 0;
}

.menu-scroll {
  padding-top: 5px;
  padding-bottom: 8px;
  width: 100vw;
  overflow-y: scroll;
  overflow-x: hidden;
  display: flex;
  background: white;
}

@media (max-width: 1024px) {
  #app-drawer-header {
    padding: 0 24px;
  }

  /* #app-drawer-header svg {
    display: inline-block;
  } */

  .availabilityBtn {
    /* top: -45px; */
  }
}

.navigation-icon {
  display: inline-flex !important;
}

.menu-badge {
  display: inline-flex;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f86567;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 12px;
  color: #fff !important;
  margin-right: 10px;
}

.mcq-count-badge {
  background-color: #ddd;
  padding: 0 8px;
  border-radius: 8px;
  margin-left: 6px;
  font-size: 12px;
}

.icon.navigation-icon:hover .mcq-count-badge, .ant-menu-item-selected .mcq-count-badge {
  background-color: #dce6fa;
}

.mainMenu--mobile .mcq-count-badge {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/v3/components/NavigationDrawer/NavigationDrawer.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,iCAAiC;EACjC,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;;;;EAIE,qDAAqD;EACrD,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;AACd;AACA,oBAAoB;AACpB;;;EAGE,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,WAAW;IACX,SAAS;EACX;;EAEA;IACE,eAAe;IACf,WAAW;IACX,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;KAEG;;EAEH;IACE,yBAAyB;IACzB,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mCAAmC;IACnC,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,iCAAiC;EACjC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE;;;IAGE,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;AACA;mCACmC;AACnC;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;;CAEC;AACD,6BAA6B;AAC7B;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA,sBAAsB;AACtB;;;EAGE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;CAEC;AACD,+BAA+B;AAC/B;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;;;;EAIE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA,6DAA6D;AAC7D;;EAEE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;;;;CAIC;;AAED,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA,2BAA2B;AAC3B;;;EAGE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;;;EAGE,6BAA6B;EAC7B,kBAAkB;EAClB;0DACwD;EACxD,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;AAChC;AACA,mCAAmC;AACnC;EACE,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;CAEC;AACD;;;EAGE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;;;;EAIE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;AAC9C;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;CAEC;;AAED;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;AACA,6BAA6B;AAC7B;;;;EAIE,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,8BAA8B,EAAE,2CAA2C;AAC7E;AACA,oBAAoB;AACpB;;EAEE,qBAAqB;AACvB;;AAEA,sBAAsB;;AAEtB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA,kBAAkB;AAClB;;;EAGE,wBAAwB;EACxB,qBAAqB;AACvB;AACA,8CAA8C;AAC9C;EACE,qDAAqD;AACvD;;AAEA;;CAEC;;AAED,UAAU;AACV;;;EAGE,eAAe;EACf,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;AACA;;;EAGE,cAAc;EACd,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB,EAAE,gBAAgB;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;;CAEC;;AAED,mCAAmC;AACnC;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;AACA,gBAAgB;AAChB;;;EAGE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;;;EAGE,uCAAuC;AACzC;AACA;;;;;;EAME,2BAA2B;EAC3B,cAAc;EACd,gCAAgC;AAClC;;AAEA;;CAEC;AACD,+BAA+B;AAC/B;EACE,WAAW;EACX;qBACmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB;iBACe;EACf,sBAAsB;EACtB,sDAAsD;EACtD,kBAAkB;EAClB,eAAe;AACjB;AACA,gCAAgC;AAChC;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,yCAAyC;AACzC;EACE,iBAAiB;AACnB;AACA,0CAA0C;AAC1C;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;CAEC;;AAED,6CAA6C;AAC7C;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;AACA,gCAAgC;AAChC;;;EAGE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;;;IAGE,uBAAuB;EACzB;AACF;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,6DAA4E;EAC5E,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;AACxB;AACA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,6DAA6E;EAC7E,wBAAwB;EACxB,kCAAkC;AACpC;AACA,wCAAwC;AACxC;;EAEE,aAAa;AACf;AACA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;AACZ;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,wCAAwC;IACxC,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,OAAO;IACP,wCAAwC;IACxC,gCAAgC;EAClC;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,+BAA+B;EACjC;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;EACA;;KAEG;EACH;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE;oCACgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,SAAS;EACX;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;EAQE,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB;kBACgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;KAEG;;EAEH;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/*\nDRAWER\n*/\n\n/* Common Drawer Settings */\n#NavDrawer {\n  display: block !important;\n  background-color: #fff !important;\n  flex: none !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  opacity: 0 !important;\n  visibility: hidden !important;\n}\n#NavDrawer.drawerStart,\n#NavDrawer.drawerMainMenu,\n#NavDrawer.drawerAllAppsMenu,\n#NavDrawer.drawerCollapsed {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04) !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n  z-index: 100;\n}\n/* Drawer expanded */\n.drawerStart,\n.drawerAllAppsMenu,\n.drawerMainMenu {\n  min-width: 350px !important;\n  max-width: 350px !important;\n  width: 350px !important;\n}\n\n.ant-menu-horizontal {\n  border-bottom: none;\n}\n\nmain.ant-layout-content {\n  /* width: calc(100vw - 350px) !important; */\n}\n\n@media only screen and (max-width: 900px) {\n  #NavDrawer .mainMenuItem {\n    display: none !important;\n  }\n\n  #NavDrawer .menu-scroll ul.mainMenu--mobile {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  #NavDrawer .menu-scroll ul.mainMenu--mobile .ant-menu-item {\n    margin: 0 !important;\n  }\n  #NavDrawer .menu-scroll ul.mainMenu--mobile .navigation-icon {\n    display: flex !important;\n    justify-content: space-between;\n  }\n\n  #NavDrawer .menu-scroll ul.mainMenu--mobile .close-icon {\n    position: fixed;\n    right: 26px;\n    top: 26px;\n  }\n\n  #NavDrawer .menu-scroll ul.mainMenu--mobile .menu-notification {\n    position: fixed;\n    right: 65px;\n    top: 14px;\n    border: none !important;\n  }\n\n  #NavDrawer .mainMenu--mobile .mainMenuItem {\n    display: block !important;\n    line-height: inherit !important;\n    border: 1px solid #F8F8F8 !important;\n  }\n\n  .mainMenuItem:nth-child(n + 5) {\n    display: block !important;\n  }\n\n  #NavDrawer .menu-notification {\n    display: block !important;\n  }\n\n  .app-drawer-header--hidden {\n    display: none !important;\n  }\n\n  #NavDrawer .menu-scroll {\n    justify-content: space-between;\n  }\n\n  #NavDrawer .menu-scroll {\n    justify-content: space-between;\n  }\n\n  .ant-menu-overflowed-submenu {\n    display: none !important;\n  }\n\n  /* #drawer_container {\n    display: none !important;\n  } */\n\n  .menuitem-overflowed {\n    display: block !important;\n    border-bottom: 1px solid #F8F8F8 !important; \n  }\n\n  #NavDrawer .mainMenu--mobile .ant-menu-item {\n    width: inherit !important;\n  }\n\n  #NavDrawer .mainMenu--mobile .ant-menu-item a.icon {\n    justify-self: flex-start !important;\n    width: 100%;\n  }\n\n  .menuMobile--avatar {\n    width: 100% !important;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  #NavDrawer .mainMenu--mobile .menuMobile--avatar .user-name {\n    height: 100% !important;\n    display: flex !important;\n    align-items: center !important;\n  }\n\n  #NavDrawer .mainMenu--mobile .menuMobile--avatar .avatar-menu--icon {\n    display: none;\n  }\n\n  #NavDrawer .mainMenu--mobile .availabilityText {\n    display: block !important;\n  }\n\n  #NavDrawer .mainMenu--mobile .availabilityIcon {\n    padding: 10px;\n  }\n\n  #NavDrawer .mainMenu--mobile .availabilityBtn--mobile {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    max-width: 100% !important;\n    width: 100%;\n    padding: 0 30px 0 10px;\n    justify-content: space-between;\n  }\n\n  #NavDrawer .mainMenu--mobile .availabilityBtn--mobile .warning-text {\n    padding-left: 20px;\n  } \n\n  #NavDrawer .mainMenu--mobile .availabilityBtn--mobile .availabilityContent--mobile {\n    display: flex;\n  }\n\n  #NavDrawer .mainMenu--mobile .ant-menu-item-selected span {\n    background-color: transparent !important;\n  }\n\n  #NavDrawer .mainMenu--mobile .ant-menu-item.ant-menu-item-disabled .menuMobile--arrowRight {\n    display: none;\n  }\n\n  #NavDrawer .mainMenu--mobile .ant-menu-item.ant-menu-item-disabled .lock-icon {\n    padding-right: 6px;\n    padding-left: 0;\n  }\n}\n\n.mainMenu--mobile {\n  width: 100vw;\n  height: 100vh;\n  z-index: 20;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  margin-top: 100px !important;\n}\n\n.mainMenu--mobile--visible {\n  display: block;\n}\n\n.mainMenu--mobile--hidden {\n  display: none;\n}\n\n.nav-right--mobile {\n  display: flex;\n  margin-left: 0 !important;\n  position: fixed;\n  right: 20px;\n  top: -2px;\n}\n\n.availabilityBtn--mobile {\n  position: fixed !important;\n  top: 40px;\n}\n\n.mainMenu--visible {\n  display: block;\n}\n\n.mainMenu--hidden {\n  display: none;\n}\n\n.mobileMenu--close {\n  position: fixed;\n  right: 20px;\n  top: 20px;\n}\n\n@media only screen and (max-width: 1400px) {\n  .drawerStart,\n  .drawerAllAppsMenu,\n  .drawerMainMenu {\n    min-width: 260px !important;\n    max-width: 260px !important;\n    width: 260px !important;\n  }\n}\n\n/* Drawer collapsed */\n.drawerCollapsed {\n  min-width: 68px !important;\n  max-width: 68px !important;\n  width: 68px !important;\n}\n\n.expires-warning {\n  text-align: left;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0;\n  color: #ff784e;\n}\n\n.expires-warning-update {\n  text-decoration: underline;\n}\n\n.open-to-offer-warning {\n  text-align: left;\n  font-size: 10px;\n  line-height: 14px;\n  letter-spacing: 0;\n  color: #888888;\n  opacity: 1;\n}\n/* Common vertical alignment\n(stretching navDrawer vertically) */\n.ant-layout-sider-children {\n  display: grid !important;\n  width: 100% !important;\n}\n.is-not-mobile .ant-layout-sider-children {\n  height: 90% !important;\n  position: fixed;\n  width: 350px !important;\n}\n\n@media only screen and (max-width: 1400px) {\n  .is-not-mobile .ant-layout-sider-children {\n    width: 260px !important;\n  }\n}\n\n.drawerCollapsed.is-not-mobile .ant-layout-sider-children {\n  width: 68px !important;\n}\n\n#NavDrawer.drawerAllAppsMenu {\n  grid-template-rows: 216px 1fr !important;\n}\n.drawerAllAppsMenu .emptyField {\n  height: 0;\n}\n.emptyField {\n  height: 148px;\n}\n/*\nLOGO BLOCK\n*/\n/* Common Logo box settings */\n#NavDrawer .logo {\n  /*  background: rgba(255, 255, 100, 1) !important; */\n  position: relative !important;\n  overflow: hidden !important;\n  height: 124px !important;\n}\n/* Logo box expanded */\n.drawerStart .logo,\n.drawerMainMenu .logo,\n.drawerAllAppsMenu .logo {\n  margin: 40px 24px 52px 24px;\n  width: 272px !important;\n}\n\n/* Logo box collapsed */\n.drawerCollapsed .logo {\n  margin: 40px 18px 52px 18px !important;\n  width: 32px !important;\n}\n\n/* Logo sign */\n.logo img {\n  width: 32px !important;\n  height: 32px !important;\n}\n\n/*\nTuring title\n*/\n/* Common Turing title styles */\n.logo h1 {\n  color: #444444;\n  font-weight: 700;\n  font-size: 20px !important;\n  padding: 0 !important;\n  line-height: 1rem !important;\n  margin: 40px 0 10px 0 !important;\n}\n\n/* Visible App Title Style */\n.logo h2 {\n  color: #42a5f5;\n  font-size: 20px !important;\n  padding: 0 !important;\n  line-height: 1rem !important;\n  white-space: nowrap;\n  font-weight: lighter;\n}\n\n/* Color of All Apps title */\n.drawerAllAppsMenu .logo h2 {\n  color: #888888;\n}\n\n/* Visible Turing title (expanded nav Drawer) */\n.drawerMainMenu .logo h1,\n.drawerMainMenu .logo h2,\n.drawerAllAppsMenu .logo h1,\n.drawerAllAppsMenu .logo h2 {\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n\n/* Hidden Turing title and App title (collapsed nav Drawer) */\n.drawerCollapsed .logo h1,\n.drawerCollapsed .logo h2 {\n  opacity: 0 !important;\n  visibility: visible !important;\n}\n\n/*\nMENU STYLING\nMain Menu styles dependence\nfrom state of NavDrawer\n*/\n\n/* Common menu settings */\n#NavDrawer .mainMenu {\n  text-align: left !important;\n}\n#NavDrawer {\n  /* height:100vh !important; */\n}\n/* Expanded menu settings */\n.drawerStart .mainMenu,\n.drawerMainMenu .mainMenu,\n.drawerAllAppsMenu .mainMenu {\n  width: 350px !important;\n  /* margin: 0 0 20px 0 !important; */\n}\n\n.drawerMainMenu .mainMenu {\n  width: 100vw !important;\n}\n\n/* Visible states of menu settings */\n.drawerCollapsed .mainMenu,\n.drawerStart .mainMenu,\n.drawerMainMenu .mainMenu {\n  padding: 0 0 0 8px !important;\n  /* height: 100%; */\n  /* max-height:100%;\n  height: calc(100vh - 216px - 48px - 100px) !important; */\n  /*  overflow: auto !important; */\n  display: flex;\n  flex-direction: row;\n  opacity: 1 !important;\n  visibility: visible !important;\n  align-items: center;\n}\n\n/* Collapsed menu settings */\n.drawerCollapsed .mainMenu {\n  width: 68px !important;\n  margin: 0 !important;\n  padding: 0 0 0 10px !important;\n}\n/* Hidden states of menu settings */\n.drawerAllAppsMenu .mainMenu {\n  margin: 0 8px !important;\n  padding: 0 !important;\n  max-height: 0 !important;\n  overflow: hidden !important;\n  opacity: 0 !important;\n  visibility: hidden !important;\n}\n\n.ant-dropdown-menu {\n  width: 140px;\n  text-align: right;\n  left: calc(84%) !important;\n}\n\n.ant-dropdown-menu-item:hover {\n  background: rgba(46, 110, 223, 0.08);\n  color: #2e6edf !important;\n}\n\n.ant-dropdown-menu-item.btn-link-font:hover {\n  background: rgba(46, 110, 223, 0.08);\n  color: #2e6edf;\n}\n\n/*\nMenu items common settings\n*/\n#NavDrawer .allApps-menu .ant-menu-item,\n#NavDrawer .mainMenu .ant-menu-item,\n#NavDrawer .ant-menu-submenu-title {\n  margin: 2px 4px !important;\n}\n#NavDrawer .ant-menu-submenu-title {\n  height: 48px !important;\n}\n#NavDrawer .container {\n  height: 48px !important;\n}\n#NavDrawer .ant-menu-submenu-active,\n#NavDrawer .material-icons,\n#NavDrawer .ant-menu-item a.icon,\n#NavDrawer .icon {\n  margin: 0px;\n  padding: 0px;\n  justify-self: center;\n  /*background-color: white; Look really bad */\n}\n#NavDrawer .text,\n#NavDrawer .label {\n  align-self: center;\n  padding-top: 2px;\n}\n\n/*\nMENU ITEMS\n*/\n\n#NavDrawer .ant-menu-submenu-title {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.mainMenu .ant-menu-submenu,\n.mainMenu .ant-menu-submenu-title {\n  margin: 0 !important;\n  padding: 0 !important;\n  height: auto !important;\n  width: 10% !important;\n}\n/* Menu items common styles */\n.mainMenu .ant-menu-item,\n.mainMenu .ant-menu-submenu-title .container,\n.mainMenu .ant-menu-sub .ant-menu-item,\n.allApps-menu .ant-menu-item {\n  font-size: 16px !important;\n  height: 48px !important;\n  color: #444444 !important;\n  line-height: 0 !important;\n  width: 10% !important;\n}\n.mainMenu .ant-menu-item-selected,\n.mainMenu .ant-menu-submenu-title {\n  border-radius: 2rem !important; /* Keep the round border, it looks better */\n}\n/* clean old style */\n.ant-menu-inline .ant-menu-item,\n.ant-menu-inline-collapsed .ant-menu-item {\n  padding: 0 !important;\n}\n\n/* Collapsed submenu */\n\n.mainMenu .ant-menu-submenu {\n  margin: 0px !important;\n  padding: 0px !important;\n  background: rgba(255, 255, 255, 0) !important;\n  height: auto !important;\n}\n.mainMenu .ant-menu-sub {\n  margin: 0px !important;\n  padding: 5px 14px !important;\n  background: rgba(255, 255, 255, 0) !important;\n  max-height: auto !important;\n}\n/* SubMenu items */\n.drawerAllAppsMenu .ant-menu-sub .ant-menu-item,\n.drawerStart .ant-menu-sub .ant-menu-item,\n.drawerMainMenu .ant-menu-sub .ant-menu-item {\n  margin: 2px 0 !important;\n  padding: 0 !important;\n}\n/* Removing default shadow in expanding menu */\n.ant-menu-inline {\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) inset !important;\n}\n\n/*\nMenu titles and labels\n*/\n\n/* Icons */\n.ant-menu-item .material-icons-round,\n.ant-menu-sub .ant-menu-item i.anticon,\n.ant-menu-submenu-title .material-icons-round {\n  font-size: 24px;\n  color: #444444;\n}\n\n/* Selected MENU styles item */\n.ant-menu-item-selected {\n  font-weight: 500;\n}\n.ant-menu-item-selected .material-icons,\n.ant-menu-item-selected span,\n.ant-menu-item-selected i {\n  color: #1890ff;\n  border-bottom-color: none !important;\n  background-color: #2e6edf14;\n}\n\n/* Submenu arrows styles*/\n.ant-menu-submenu .ant-menu-submenu-arrow {\n  top: 50% !important;\n  right: 16px !important;\n  color: #444444 !important;\n}\n\n/* Selected SUBMENU item*/\n.ant-menu-sub .ant-menu-item {\n  margin-top: 4px !important;\n  margin-bottom: 4px !important;\n  margin-right: 16px !important;\n  padding-left: 16px !important;\n  padding-top: 3px;\n  padding-bottom: 3px;\n  border-radius: 2rem; /* Look better */\n  font-size: 16px;\n  color: #666666;\n}\n\n/*\nSubmenu popups\n*/\n\n/* Popups windows inside paddings */\n.ant-menu-submenu-popup .ant-menu-sub {\n  padding: 1rem 0.5rem !important;\n}\n\n.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item {\n  margin: 0 auto !important;\n}\n/* popup menus */\n.ant-menu-submenu-popup .ant-menu-sub,\n.ant-menu-submenu-popup .ant-menu-item,\n.ant-menu-submenu-popup .ant-menu-item span {\n  width: auto !important;\n}\n.ant-menu-submenu-popup {\n  left: 75px !important;\n  width: auto !important;\n}\n.ant-menu-submenu-popup .ant-menu-item {\n  display: grid !important;\n  margin: 0 12px !important;\n  border-radius: 0 !important;\n}\n\n/* Menu items hover effects */\n.ant-menu-item-selected.bgc-turing-ly-dashboard .text,\n.ant-menu-item-selected.bgc-turing-ly-dashboard:hover .text,\n.ant-menu-item-selected.bgc-turing-ly-dashboard .text:hover {\n  color: rgba(236, 64, 122, 1) !important;\n}\n.ant-menu-root\n  .ant-menu-submenu-active:not(.ant-menu-item-selected)\n  .ant-menu-submenu-title,\n.ant-menu-root .ant-menu-item-active:not(.ant-menu-item-selected),\n.ant-menu-root\n  .ant-menu-item.ant-menu-item-active:not(.ant-menu-item-selected) {\n  background-color: #2e6edf14;\n  color: #2e76d4;\n  border-radius: 0.6rem !important;\n}\n\n/*\nLog Out\n*/\n/* Log Out on expanded Drawer */\n.LogOut {\n  width: 100%;\n  /* height: 80px;\n  max-height: 80px; */\n  overflow: hidden;\n  /* padding: 24px 20px; */\n  /* position: fixed;\n  bottom: 68px; */\n  background-color: #fff;\n  /* box-shadow: 0px -10px 10px -10px rgba(0,0,0,0.1); */\n  /* z-index: 100; */\n  cursor: pointer;\n}\n/* Log Out on collapsed Drawer */\n.drawerCollapsed .LogOut {\n  width: 68px;\n  padding: 24px 16px;\n  text-align: center;\n  overflow: hidden;\n}\n/* Visible user name on expanded Drawer */\n.LogOutText {\n  margin-left: 16px;\n}\n/* Inisible user name on expanded Drawer */\n.drawerCollapsed span.LogOutText {\n  opacity: 0;\n  visibility: hidden;\n  height: 0;\n  width: 0;\n  overflow: hidden;\n}\n\n/*\nCollapsing trigger\n*/\n\n/* Common collapsing trigger for all states */\n.ant-layout-sider-trigger {\n  height: 68px;\n  padding-right: 32px;\n  border-top: 1px solid #eeeeee;\n  text-align: right;\n  background-color: #fafafa;\n  position: fixed;\n  bottom: 0;\n  cursor: pointer;\n}\n/* Collapsing trigger expanded */\n.drawerMainMenu .ant-layout-sider-trigger,\n.drawerStart .ant-layout-sider-trigger,\n.drawerAllAppsMenu .ant-layout-sider-trigger {\n  width: 350px !important;\n  z-index: 100;\n}\n\n@media only screen and (max-width: 1400px) {\n  .drawerMainMenu .ant-layout-sider-trigger,\n  .drawerStart .ant-layout-sider-trigger,\n  .drawerAllAppsMenu .ant-layout-sider-trigger {\n    width: 260px !important;\n  }\n}\n\n/* Collapsing trigger expanded icon */\n.ant-layout-sider-trigger i {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin: 22px 0;\n  background: url(\"../../../assets/img/round-chevron_left-24px.svg\") no-repeat;\n  background-size: contain;\n  background-position: center center;\n  vertical-align: middle;\n}\n/* Removing default chevron */\n.ant-layout-sider-trigger i svg {\n  display: none;\n}\n\n/* Collapsing trigger collapsed */\n.drawerCollapsed .ant-layout-sider-trigger {\n  width: 68px !important;\n  padding-left: 20px !important;\n}\n\n/* Collapsing trigger collapsed icon */\n.ant-layout-sider-collapsed .ant-layout-sider-trigger i {\n  background: url(\"../../../assets/img/round-chevron_right-24px.svg\") no-repeat;\n  background-size: contain;\n  background-position: center center;\n}\n/* Hiding icons in popups and tooltips */\n.ant-menu-submenu-popup .material-icons,\n.ant-tooltip-inner .material-icons {\n  display: none;\n}\n/* Tooltips styles */\n.ant-tooltip-inner .label {\n  padding: 2px 2px 0 2px;\n  display: none;\n}\n\n#NavDrawer .ant-menu.ant-menu-dark .ant-menu-item-selected,\n#NavDrawer .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {\n  background-color: rgba(66, 165, 245, 0.08);\n}\n\n#NavDrawer .ant-menu-inline .ant-menu-selected::after,\n#NavDrawer .ant-menu-inline .ant-menu-item-selected::after {\n  opacity: 0;\n}\n\n/* Mobile screen Menu button */\n\n#mob-menu-btn {\n  display: none;\n  position: fixed;\n  top: 20px;\n  right: 23px;\n  z-index: 999;\n  padding: 5px 10px 5px 10px;\n  width: auto;\n  height: auto;\n  cursor: pointer;\n  /* background-color: #FFF; */\n  border-radius: 4px;\n  /* box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04) !important; */\n}\n\n#mob-menu-btn .bar1,\n.bar2,\n.bar3 {\n  display: block;\n  width: 27px;\n  height: 2px;\n  background-color: #212121;\n  margin: 6px 0;\n  transition: 0.4s;\n}\n\n#NavDrawer.is-mobile + #mob-menu-btn .bar1 {\n  -webkit-transform: rotate(-45deg) translate(-7px, 4px);\n  transform: rotate(-45deg) translate(-7px, 4px);\n}\n\n#NavDrawer.is-mobile + #mob-menu-btn .bar2 {\n  opacity: 0;\n}\n\n#NavDrawer.is-mobile + #mob-menu-btn .bar3 {\n  -webkit-transform: rotate(45deg) translate(-6px, -6px);\n  transform: rotate(45deg) translate(-6px, -6px);\n}\n\n@media (min-width: 350px) and (max-width: 900px) {\n  #NavDrawer {\n    position: fixed;\n    top: 0;\n    z-index: 998 !important;\n    width: 70% !important;\n    min-width: 70% !important;\n    -webkit-transition: all 0.25s !important;\n    transition: all 0.25s !important;\n  }\n\n  .mobileHeader {\n    display: flex;\n    justify-content: center;\n    background-color: white !important;\n    z-index: 3;\n  }\n\n  .mobileHeader.mobileVisible {\n    display: flex;\n    justify-content: space-between !important;\n  }\n\n  .mobileHeader .logoHolder {\n    display: flex;\n    gap: 5px;\n    padding: 20px;\n  }\n\n  .mobile-header-notification {\n    font-size: 26px;\n    line-height: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-right: 16px;\n    flex: 1;\n  }\n\n  .mobile-header-notification > svg {\n    font-size: 26px;\n  }\n\n  .mobile-header-text {\n    height: 70px;\n    padding: 20px;\n  }\n\n  .titleBlock {\n    padding-top: 2rem;\n    padding-left: 0 !important;\n  }\n\n  .ant-layout-header h1 {\n    font-size: 20px !important;\n    margin-left: 0 !important;\n  }\n\n  .secondaryTitle.ant-layout-header {\n    padding-left: 30px !important;\n    box-shadow: none !important;\n  }\n\n  .mainMenu .ant-menu-item,\n  .mainMenu .ant-menu-submenu-title .container,\n  .mainMenu .ant-menu-sub .ant-menu-item,\n  .allApps-menu .ant-menu-item {\n    font-size: 12px !important;\n  }\n\n  .mobileMenuRight {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    padding-right: 20px;\n  }\n\n  #NavDrawer.is-mobile {\n    left: 0;\n    -webkit-transition: all 0.25s !important;\n    transition: all 0.25s !important;\n  }\n  #NavDrawer.is-mobile .logo {\n    height: 80px !important;\n    margin: 10px 24px;\n    display: flex;\n    justify-content: space-between;\n    width: 60vw !important;\n  }\n  #NavDrawer.is-mobile .logo .logo-img {\n    display: none;\n  }\n  #NavDrawer.is-mobile .logo h1 {\n    margin: 8px 0 15px 0 !important;\n  }\n  .mainMenuContainer {\n    display: block;\n    position: absolute;\n    top: 89px;\n    width: 100%;\n  }\n  #NavDrawer ul.mainMenu {\n    width: 100% !important;\n    padding-right: 10px !important;\n  }\n  #NavDrawer .ant-layout-sider-trigger {\n    display: none;\n  }\n  #NavDrawer .LogOut {\n    bottom: 0;\n  }\n\n  #mob-menu-btn {\n    display: block !important;\n  }\n\n  .ant-layout .titleBlock {\n    padding: 1rem 0 0 1rem;\n  }\n  /* .ant-layout-header h1 {\n    margin: 20px 0 0 10px !important;\n  } */\n  .ant-layout .ant-layout-content {\n    width: 100% !important;\n    max-width: 100%;\n  }\n\n  .ant-table-body {\n    overflow-x: auto;\n  }\n}\n\n.launchScreen .ant-menu-item,\n#NavDrawer .ant-menu-item,\n#NavDrawer .mainMenu .ant-menu-submenu-title > .container {\n  width: auto !important;\n  grid-template-columns: none !important;\n}\n\n.divider {\n  margin: 10px;\n  background-color: #eee;\n}\n\n#NavDrawer .icon {\n  align-items: center;\n  justify-content: center;\n  /* border-left: 10px solid white;  */\n}\n\n.ant-menu-item-active .icon {\n  /* border-left: 10px solid #E9E9E9 !important; */\n}\n\n.ant-menu-item-selected .icon {\n  /* border-left: 10px solid #EEEEEE !important; */\n}\n\n@media (min-width: 350px) and (max-width: 900px) {\n  #NavDrawer ul.mainMenu {\n    width: 100% !important;\n    padding-right: 10px !important;\n    display: flex;\n  }\n\n  #NavDrawer.drawerMainMenu {\n    /* opacity: 0 !important;\n    visibility: hidden !important; */\n    background: transparent !important;\n  }\n\n  .close-icon {\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 10px;\n  }\n}\n\n.close-icon {\n  display: none;\n}\n\n.ant-menu-horizontal > .ant-menu-item:hover,\n.ant-menu-horizontal > .ant-menu-submenu:hover,\n.ant-menu-horizontal > .ant-menu-item-active,\n.ant-menu-horizontal > .ant-menu-submenu-active,\n.ant-menu-horizontal > .ant-menu-item-open,\n.ant-menu-horizontal > .ant-menu-submenu-open,\n.ant-menu-horizontal > .ant-menu-item-selected,\n.ant-menu-horizontal > .ant-menu-submenu-selected {\n  border-bottom: none !important;\n  background: #2e6edf14;\n  border-radius: none;\n}\n\n#ant-menu-item-selected {\n  border-bottom: none !important;\n  background: #2e6edf14;\n  border-radius: none;\n  color:#1890ff !important;\n}\n\n#ant-menu-item-selected a{\n  color:#1890ff !important;\n}\n\n.mainMenu .ant-menu-item-selected,\n.mainMenu .ant-menu-submenu-title {\n  border-radius: 0.6rem !important;\n}\n\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  background-color: #eeeeee;\n  border-radius: 0 !important;\n}\n\n.menu-item-disabled {\n  opacity: 0.5;\n}\n\n.lock-icon {\n  padding-left: 10px;\n}\n\n.user-profile {\n  cursor: pointer;\n}\n\n.title-row {\n  width: 100%;\n  font: normal normal normal 14px/19px;\n  font-weight: 300;\n  color: #888888;\n}\n\n.challenge-status-icon {\n  border-radius: 50px;\n  margin-right: 20px !important;\n  color: white !important;\n  font-weight: 500;\n}\n\n.callout-icon {\n  background-color: orange !important;\n}\n\n.passed-icon {\n  background-color: #77bb58 !important;\n}\n\n.availabilityIcon {\n  opacity: 1;\n  fill: #444;\n}\n\n.availabilitySection {\n  /* margin-top: 20px; */\n  /* bottom: 10px; */\n  /* position: fixed;\n  bottom: 152px; */\n  z-index: 100;\n  align-self: flex-end;\n}\n\n.flex-section {\n  display: flex;\n  flex: 1;\n}\n\n.availabilityBtn {\n  /* background-color: #eaeaea !important; */\n  display: flex;\n  align-items: center;\n  border-radius: 50px;\n  border: none !important;\n  height: 50px !important;\n  max-width: 240px !important;\n  /* top: -68px; */\n  text-align: left;\n}\n\n.availabilityBtn.ant-btn {\n  padding: 8px 12px;\n  /* margin-bottom: -26px; */\n}\n\n.nav-right {\n  display: flex;\n  margin-left: auto;\n  margin-right: 20px;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n}\n\n.availabilityText {\n  margin: 5px;\n}\n\n@media only screen and (max-width: 1100px) {\n  .availabilityText {\n    display: none !important;\n  }\n\n  .user-name {\n    display: none;\n  }\n}\n\n.drawerCollapsed .availabilitySection {\n  width: 50px !important;\n  min-width: 50px !important;\n  overflow: hidden;\n}\n\n.drawerCollapsed span.availabilityText {\n  opacity: 0;\n  display: none;\n  height: 0;\n  width: 0;\n  overflow: hidden;\n  margin: 0;\n}\n\n/* Side Navigation refactor styling */\n#drawer_container {\n  position: fixed;\n  /* height: 100%; */\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.user-name {\n  padding-right: 10px;\n}\n\n.menu-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.menu-scroll {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.flex {\n  flex: 1 !important;\n}\n\n#turing_logo {\n  display: block;\n}\n\n#title {\n  transition: opacity 0.3s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n}\n\n#t_logo {\n  display: block;\n}\n\n#app-drawer-header svg {\n  display: none;\n}\n\n#app-drawer-header {\n  padding: 0 24px;\n  /* padding-top: 25px; */\n  /* min-height: 166px; */\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n}\n\n.ant-layout-sider-collapsed #t_logo {\n  display: block;\n}\n\n.ant-layout-sider-collapsed #turing_logo {\n  display: none;\n}\n\n.main-menu {\n  /* flex: 1; */\n  display: flex;\n  flex-direction: column;\n}\n\n.bottom-menu {\n  height: 48px !important;\n}\n\n/* #app-drawer{\n  box-shadow: 0 1px 2px rgba(0,0,0,0.08);\n  transition-property: width, visibility;\n} */\n\n.ant-layout-sider-collapsed .title-row {\n  display: none;\n}\n\n.ant-menu-submenu-selected {\n  border-bottom-color: none !important;\n}\n\n.drawerCollapsed .availabilityBtn {\n  border-radius: 50%;\n  height: 50px !important;\n  width: 50px !important;\n  min-width: 50px !important;\n  margin-left: 0 !important;\n}\n\n.avatar-user {\n  margin-left: 12px;\n}\n\n.drawerCollapsed .avatar-user {\n  display: none;\n}\n\n.avatar-container {\n  margin-left: 9px;\n}\n\n#drawer_spacer {\n  width: 0;\n}\n\n.menu-scroll {\n  padding-top: 5px;\n  padding-bottom: 8px;\n  width: 100vw;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  display: flex;\n  background: white;\n}\n\n@media (max-width: 1024px) {\n  #app-drawer-header {\n    padding: 0 24px;\n  }\n\n  /* #app-drawer-header svg {\n    display: inline-block;\n  } */\n\n  .availabilityBtn {\n    /* top: -45px; */\n  }\n}\n\n.navigation-icon {\n  display: inline-flex !important;\n}\n\n.menu-badge {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #f86567;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  line-height: 12px;\n  color: #fff !important;\n  margin-right: 10px;\n}\n\n.mcq-count-badge {\n  background-color: #ddd;\n  padding: 0 8px;\n  border-radius: 8px;\n  margin-left: 6px;\n  font-size: 12px;\n}\n\n.icon.navigation-icon:hover .mcq-count-badge, .ant-menu-item-selected .mcq-count-badge {\n  background-color: #dce6fa;\n}\n\n.mainMenu--mobile .mcq-count-badge {\n  font-size: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
